import { ButtonCard as VuiButtonCard } from '@village/ui';
import { rem } from 'polished';
import styled from 'styled-components';

const Container = styled.div`
    display: inline-flex;
    flex-direction: column;
    gap: ${rem(16)};
    width: 100%;
`;

const Wrapper = styled.div`
    display: inline-flex;
    flex-direction: column;
    gap: ${rem(16)};
`;

const ButtonCard = styled(VuiButtonCard)<{ $isPreSelected: boolean }>`
    font-family: CeraProBold, arial, sans-serif;
    align-content: center;
    height: ${rem(72)};
    border-width: 2px;
    border-style: solid;
    border-color: ${({ theme, $isPreSelected }) =>
        $isPreSelected
            ? theme.vui.component.buttonCard.selected.borderColor
            : theme.vui.component.buttonCard.default.borderColor};
    border-radius: ${({ theme }) => theme.vui.component.buttonCard.default.borderRadius};
    padding: ${rem(24)} ${rem(20)};

    & svg {
        color: ${({ theme }) => theme.vui.colors.icon.default};
    }

    @media (hover: hover) {
        &:hover {
            border-color: ${({ theme }) => theme.vui.component.buttonCard.hover.borderColor};
        }
    }

    &:active {
        border-color: ${({ theme }) => theme.vui.component.buttonCard.selected.borderColor};
    }
`;

export { Container, ButtonCard, Wrapper };
